export default __webpack_public_path__ + "static/media/search.d6bdd0e4.svg";